import { memo, type ReactNode } from 'react';

interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'disabled';
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

export const Button = memo(function Button({ 
  variant = 'primary', 
  children, 
  onClick, 
  className = '',
  disabled = false,
  fullWidth = false,
  type = 'button'
}: ButtonProps) {
  const baseStyles = 'px-6 py-3.5 rounded-2xl transition-smooth font-semibold shadow-sm';
  
  const variants = {
    primary: 'bg-gradient-to-r from-primary to-primary-dark text-white hover:shadow-md hover:-translate-y-0.5 active:scale-95',
    secondary: 'bg-white text-primary border-2 border-slate-200 hover:border-primary/30 hover:shadow-md hover:-translate-y-0.5 active:scale-95',
    disabled: 'bg-slate-200 text-slate-400 cursor-not-allowed'
  };

  const widthClass = fullWidth ? 'w-full' : '';

  return (
    <button
      type={type}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={`${baseStyles} ${variants[disabled ? 'disabled' : variant]} ${widthClass} ${className}`}
      aria-disabled={disabled}
    >
      {children}
    </button>
  );
});